import { AutogenModelIntellirouteCity, AutogenRowIntellirouteCity } from "./autogen/AutogenModelIntellirouteCity";

export class ModelIntellirouteCity extends AutogenModelIntellirouteCity<RowIntellirouteCity> {
	constructor() {
		super(RowIntellirouteCity);
	}
}

export class RowIntellirouteCity extends AutogenRowIntellirouteCity {
}